"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    prizesLink: {
        display: 'flex',
        textDecoration: 'none',
        marginTop: theme.spacing(2),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.common.white
        }
    },
    winnerStats: {
        marginTop: theme.spacing(2)
    },
    prizeWinners: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(5)
    },
    oddRow: {
        backgroundColor: theme.palette.grey['200']
    },
    evenRow: {
        backgroundColor: theme.palette.common.white
    },
    prizeSummary: {
        marginBottom: theme.spacing(2)
    },
    prizeContent: {
        marginBottom: theme.spacing(2)
    },
    divider: {
        backgroundColor: theme.palette.text.secondary,
        marginBottom: theme.spacing(5)
    }
});
exports.default = styles;
//# sourceMappingURL=DialogStyle.js.map